module.exports = __webpack_public_path__ + "static/media/Developmenticon02.b82d0439.png";